<template>
  <div style="background-color: rgba(96,95,89,0.38); border-radius: 15px; padding: 10px">
    <b-row style="margin-top: 15px">
      <b-col>
        <Iona
            v-if="profile"
            class="float-right"
            :profile="profile"
        />
      </b-col>
    </b-row>
    <b-row style="margin-top: 25px">
      <b-col>
            <span v-for="(anInfo, i) in info" :key="`info-${i}`">
            {{anInfo}}
            </span>
      </b-col>
    </b-row>
    <hr />
    <b-row style="margin-top: 25px">
      <b-col>
        <b-icon
            icon="hand-thumbs-up"
            scale="2"
            variant="dark"
            style="margin-left: 15px;"
        />
        <b-icon
            icon="hand-thumbs-down"
            scale="2"
            variant="dark"
            style="margin-left: 15px; margin-right: 15px;"
        />
        Was this info helpful?
      </b-col>
      <b-col>
        <b-button
            pill
            variant="dark"
            style="margin-left: 15px;"
            class="float-right"
        >
          Automate
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Iona from "@/components/common/iona";
import ToggleSingle from '@/components/common/toggleSingle';
export default {
  name: "HeartBeat_CarePlan_Block",
  components: {
    Iona,
    ToggleSingle
  },
  created(){},
  beforeMount() {},
  mounted() {},
  props: {
    heartbeat: {
      type: Object,
      required: true,
      default: () => {}
    },
    profile: {
      type: Object,
      required: true,
      default: () => {}
    },
    apps: {
      type: Array,
      required: true,
      default: () => {return []}
    },
    info: {
      type: Array,
      required: true,
      default: () => { return []}
    },
  },
  computed: {
    ...mapGetters({})
  },
  methods: {},
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.container .vue-grid-item.vue-grid-placeholder {
  background: #c0c081;
}
</style>